import { FontIcon, mergeStyles, Stack, Text } from '@fluentui/react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

export class WidgetOutlineState {
	
	public title?: string;
	public footer?: string;
	public icon?: string;
	public iconColor?: string;
	public height?: number;
	public width?: number;

	public expanded: boolean = true;

	public toggle() {
		this.expanded = !this.expanded;
	}

	public constructor(title:string, icon?:string, iconColor?:string, expanded:boolean = true) {
		this.title = title;
		this.icon = icon;
		this.iconColor = iconColor;
		this.expanded = expanded;
		makeAutoObservable(this);
	}
}

class WidgetOutline extends React.Component<IWidgetOutlineProps> {
	render() {
		const iconClass = mergeStyles({
			fontSize: 18,
			color: this.props.state.iconColor || 'black',
		});

		const titleClass = mergeStyles({
			fontWeight: 200,
		});

		let height = 'fit-content';
		let minWidth = 'auto';
		let style: any = { height: height, minWidth: minWidth, marginBottom:20 };

		if (this.props.state.width) {
			style.width = this.props.state.width;
		}

		return (
			<div className="widgetOutline" style={style}>
				<Stack style={{ height: this.props.state.height }}>

					<Stack.Item grow={true} onClick={() => this.props.state.toggle()} style={{cursor:'pointer', userSelect:'none'}}>
						<Stack horizontal style={{margin:10}}>
							<Stack.Item grow={true}>
								{this.props.state.title ? (
									<Text className={titleClass}>{this.props.state.title}</Text>
								) : (
									<></>
								)}
							</Stack.Item>

							{this.props.state.icon ? (
								<Stack.Item>

									{/* An emoji can be 1-3 chars. There are better ways to detect emoji... */}
									{ this.props.state.icon.length <= 3 ? 
										<span className={iconClass}>{this.props.state.icon}</span> 
										:
										<FontIcon iconName={this.props.state.icon} className={iconClass} />
									}
								</Stack.Item>
							) : (
								<></>
							)}

							<Stack.Item>
								<FontIcon
									iconName={this.props.state.expanded ? 'ChevronUp' : 'ChevronDown'}
									className={mergeStyles({ userSelect:'none', cursor: 'pointer', marginLeft: 10, fontSize: 12, color: '#888' })}
								/>
							</Stack.Item>
						</Stack>
					</Stack.Item>
						
					{this.props.state.expanded &&
						<Stack.Item>
							<div style={{padding:10}}>{this.props.children}</div>
						</Stack.Item>
					}

					{this.props.state.footer ? (
						<Stack.Item>
							<Text style={{ padding:10, fontSize: '11px' }}>{this.props.state.footer}</Text>
						</Stack.Item>
					) : (
						<></>
					)}
				</Stack>
			</div>
		);
	}
}

export interface IWidgetOutlineProps {

	state: WidgetOutlineState;
}

export default observer(WidgetOutline);
